<template>
  <router-view />
  <v-overlay v-if="load" class="overlay_main" persistent :model-value="load">
    <img src="@/assets/images/base/loading.svg" alt="loading.." />
  </v-overlay>
</template>
<script setup lang="ts">
import { computed } from "vue";
const load = computed(() => window.$load?.value);
</script>
